
import BaseAPI from '../base/baseApi';

export default class IntegrationApi extends BaseAPI {
  apiName = 'Integration';
}
